import styles from './WorkspacePages.module.css';

/**
 * The import job endpoints and file staging are not implemented by the dev
 * backend yet. Say so in place; a control that cannot act is not shown.
 */
export function ImportExperience() {
  return (
    <section className={styles.importRow} aria-labelledby="import-evidence-title">
      <h2 id="import-evidence-title" className="sr-only">
        Import supplied evidence
      </h2>
      <p className={styles.sectionCopy}>
        Import is not available yet. Evidence arrives from discovery runs; no file is read or sent.
      </p>
    </section>
  );
}
